
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class SwitcherComponent extends Vue {
  @Prop({ type: Boolean, default: false }) value: boolean
  
  switchValue() { this.$emit('input', !this.value); }
}
